<template>
  <v-container>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <v-skeleton-loader v-if="!data_loaded" type="table"></v-skeleton-loader>
        <v-card v-if="data_loaded">
          <v-card-title class="align-center">
            <div class="d-flex align-center">
              <v-icon x-large>mdi-sale</v-icon>
              <h1 class="ms-3">מבצעי מותגים</h1>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              v-if="$store.getters.permission('brand_campaigns create')"
              color="primary"
              to="/brand-campaign"
            >מבצע חדש</v-btn>
          </v-card-title>
          <v-data-table
            :mobile-breakpoint="0"
            :hide-default-footer="true"
            :disable-pagination="true"
            :items="items"
            :headers="headers"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                class="px-2"
                x-small
                :color="item.status == 1 ? 'success black--text' : 'error'"
              >
                {{ item.status == 1 ? "פעיל" : "לא פעיל" }}
              </v-chip>
            </template>
            <template v-slot:[`item.delivery_discount_percentage`]="{ item }">
              {{ item.delivery_discount_percentage }}%
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                v-if="$store.getters.permission('brand_campaigns edit')"
                :to="`/brand-campaign/${item.id}`"
                small
                icon
              >
                <v-icon small>edit</v-icon>
              </v-btn>
              <v-btn
                small
                icon
                v-if="$store.getters.permission('brand_campaigns delete')"
                @click="delete_row(item.id)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
        <DeleteDialog
          v-if="$store.getters.permission('brand_campaigns delete')"
          @delete_done="get_data()"
          @close_delete="delete_obj.delete_prop = false"
          :delete_obj="delete_obj"
        ></DeleteDialog>
      </div>
    </div>
  </v-container>
</template>

<script>
import DeleteDialog from "@/components/public/delete.vue";

export default {
  name: "brand_campaigns",
  data() {
    return {
      data_loaded: false,
      items: [],
      delete_obj: {
        title: "מבצע מותג",
        delete_prop: false,
        delete_url: "brand-campaigns",
        id: 0,
      },
      headers: [
        { text: "שם", value: "campaign_name" },
        { text: "סכום מינימלי", value: "total_to_get_discount" },
        { text: "% הנחה", value: "delivery_discount_percentage" },
        { text: "תאריך התחלה", value: "start_date" },
        { text: "תאריך סיום", value: "end_date" },
        { text: "סטטוס", value: "status" },
        { text: "תאריך יצירה", value: "created_at" },
        { text: "פעולות", value: "actions", sortable: false },
      ],
    };
  },
  components: {
    DeleteDialog,
  },
  mounted() {
    this.get_data();
  },
  methods: {
    get_data() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: "brand-campaigns",
            method: "get",
          },
        })
        .then((res) => {
          this.items = (res.data && res.data.data) || [];
          this.data_loaded = true;
        });
    },
    delete_row(id) {
      this.delete_obj.id = id;
      this.delete_obj.delete_prop = true;
    },
  },
};
</script>
